export default __webpack_public_path__ + "static/media/success.8ed21814.gif";